import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const Render19 = ({ type, mode }) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "renders/206_1801_top_view_day_2k.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000, toFormat: JPG, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  let selectedMode = (mode) ? mode : 'cover';
  // Construct font-family declaration for object-fit-images
  const objFit = selectedMode; //props.objFit ? props.objFit : `cover`
  const objPosition = `50% 50%`
  const fontFamily = `"object-fit: ${objFit}; object-position: ${objPosition}"`

  const imgStyle = {
    objectFit: objFit,
    objectPosition: objPosition,
    fontFamily: fontFamily
  }

  if (type !== 'gallery') {
    return <Img fluid={data.placeholderImage.childImageSharp.fluid} imgStyle={{ ...imgStyle }} />
  } else {
    return <Img fluid={data.placeholderImage.childImageSharp.fluid} placeholderClassName="placeholder-none" imgStyle={{ ...imgStyle }} />
  }
  
}

export { Render19 }
